export function isOkResponse(status: number) {
    return status >= 200 && status <= 299
}
